module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_07-6f6f9305b705834065c5a30b2b4fac71.svg";